import React from "react";
import styled from "styled-components";
import { Icon } from "Assets/icon";
import media from "Styles/media";
import TextParagraph from "Components/Text/TextParagraph";
interface BtnIconProps {
	icon: string;
	onClick?: () => void;
	className?: string;
	color?: string;
	text?: string;
	bgColor?: string;
	hoverBgColor?: string;
}
const Wrapper = styled.div<{ isText: boolean; bgColor?: string; hoverBgColor?: string }>`
	position: relative;
	display: flex;
	align-items: center;
	cursor: pointer;
	padding-left: ${(props) => (props.isText ? "16px" : 0)};
	border-radius: 1000px;
	background-color: ${(props) => (props.bgColor ? props.bgColor : "transparent")};

	&:after {
		content: "";
		display: block;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 0;
		height: 0;
		border-radius: 1000px;
		transition: ${(props) => props.theme.transition.hover};
		background-color: ${(props) => (props.hoverBgColor ? props.hoverBgColor : props.theme.color.gray.light)};
	}

	@media ${media.hover} {
		&:hover {
			&:after {
				width: 100%;
				height: 100%;
			}
		}
	}
`;

const BtnWrapper = styled.div`
	width: 40px;
	height: 40px;
	color: white;
	position: relative;
	z-index: 1;
	${(props) => props.theme.layout.center_flex};
`;

const BtnIcon: React.FC<BtnIconProps> = ({ icon, onClick, className, color, text, bgColor, hoverBgColor }) => {
	return (
		<Wrapper className={className} onClick={onClick} isText={!!text} bgColor={bgColor} hoverBgColor={hoverBgColor}>
			{text && <TextParagraph value={text} />}
			<BtnWrapper>
				<Icon name={icon} color={color} />
			</BtnWrapper>
		</Wrapper>
	);
};

export default BtnIcon;
